<div class="label-section">
  @if (required()) {
  <span class="input-label"
    >{{ label() | translateLang }}<span class="required-asterisk"
      >*</span
    ></span
  >
  <span class="required-message">{{ 'contribute.required' | translateLang }}</span>
  } @else {
  <span class="input-label">{{ label() | translateLang }}</span>
  }
</div>
<section class="input-container">
  <div class="amount-section">
    <input
      type="text"
      [class]="isInvalid() ? 'input-amount p-invalid' : 'input-amount'"
      [value]="displayAmount()"
      [placeholder]="'contribute.section4.amount.placeholder' | translateLang"
      [disabled]="disabled()"
      (input)="onAmountInput($event)"
      (blur)="onAmountBlur($event)"
      (keydown)="onAmountKeyDown($event)"
      aria-label="Amount"
    />
  </div>
  <div
    class="currency-section"
    [class.has-clear]="!selectionArrow() && currency() && !disabled() && !currencyDisabled()"
    [class.has-dropdown-arrow]="showDropdownArrow()"
  >
    <p-autoComplete
      #currencyAutoComplete
      [inputStyleClass]="isInvalid() ? 'input-currency p-invalid' : 'input-currency'"
      [(ngModel)]="currency"
      [suggestions]="dropDownItems()"
      [scrollHeight]="currencyScrollHeight()"
      [optionLabel]="'symbol'"
      [dataKey]="'symbol'"
      [completeOnFocus]="true"
      [forceSelection]="false"
      [placeholder]="placeholder() | translateLang"
      [showClear]="false"
      [fluid]="true"
      [disabled]="disabled() || currencyDisabled()"
      (completeMethod)="filter($event)"
      (onShow)="onCurrencyShow()"
      (onHide)="onCurrencyHide()"
      (onBlur)="handleBlur()"
      (onClear)="clearCurrency()"
      aria-label="Currency"
    />
    @if (!selectionArrow() && currency() && !disabled() && !currencyDisabled()) {
    <button
      class="currency-clear-button"
      (click)="clearCurrency()"
      type="button"
      aria-label="Clear currency"
    >
      <app-icon name="close" [size]="6" color="white" />
    </button>
    }
    @if (showDropdownArrow()) {
    <span class="currency-dropdown-arrow" [class.currency-dropdown-arrow--open]="isDropdownOpen()" (click)="onArrowClick()" aria-hidden="true">
      <app-icon name="chevron-down" [size]="10" color="#9F9696" />
    </span>
    }
  </div>
</section>

@if (displayErrorMessage()) {
<span class="error-message" role="alert">{{ displayErrorMessage() }}</span>
}
